import { RespEntityUtil } from './respEntityUtil';

/**
 * 带有编码的公用类
 * @author miqiang
 * @date 2019-10-23
 */
export class RespCodeEntityUtil extends RespEntityUtil {

    /**
     * 编码
     */
    public code: string;

    constructor(openid: string, code: string, name: string) {
        super(openid, name);
        this.code = code;
    }
}